var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { cgx } from "@springcare/dsm";
export var ButtonSizes = {
    "v-sm": {
        px: "v-16",
        py: "v-8",
        borderRadius: "v-lg",
    },
    "v-md": {
        px: "v-16",
        py: "v-12",
        borderRadius: "v-lg",
    },
    "v-lg": {
        px: "v-24",
        py: "v-16",
        borderRadius: "v-lg",
    },
};
/**
 * Icon Button sizes
 *
 * Note 1: IconButtons use the same theme as buttons. Chakra recommend creating variants/sizes if you have anything specific for icons,
 * in our case using a suffix for icons. for example `v-3xs-icon`.
 * Note 2: Icon Buttons use a set width and height, we don't have tokens for that at the moment, so using plain values
 */
export var IconButtonSizes = {
    "v-3xs-icon": {
        width: "16px",
        height: "16px",
        fontSize: "14px",
        borderRadius: "v-sm",
    },
    "v-2xs-icon": {
        width: "24px",
        height: "24px",
        fontSize: "14px",
        borderRadius: "v-md",
    },
    "v-xs-icon": {
        width: "32px",
        height: "32px",
        fontSize: "14px",
        borderRadius: "v-md",
    },
    "v-sm-icon": {
        width: "v-lg",
        height: "v-lg",
        fontSize: "18px",
        borderRadius: "v-lg",
    },
    "v-md-icon": {
        width: "48px",
        height: "48px",
        fontSize: "18px",
        borderRadius: "v-lg",
    },
    "v-lg-icon": {
        width: "56px",
        height: "56px",
        fontSize: "18px",
        borderRadius: "v-lg",
    },
};
/**
 * Icon Button sizes
 *
 * Note: Tag clickable is just a button, so is much easier for us to create a new size here instead.
 */
export var TagClickableSizes = {
    "v-3xs-tag": __assign(__assign({}, cgx.textStyles["body-small-regular"]), { p: "v-4", border: "none", borderRadius: "v-md" }),
};
export var TextButtonSizes = {
    "v-md-text": __assign(__assign({}, cgx.textStyles["body-small-regular"]), { px: "v-4", py: "v-8", border: "none", borderRadius: "v-md" }),
};
